import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { AVATAR_WIDTH } from '../../constants';

// We should switch to using the GalaxyAvatarModule in the future if it gets an option for this.

@Component({
  selector: 'crm-unknown-user-avatar',
  template: `
    <!-- background color is $glxy-grey-500 = #9e9e9e -->
    <glxy-avatar [width]="width" icon="person" backgroundColor="#9e9e9e"></glxy-avatar>
  `,
  providers: [],
  imports: [CommonModule, GalaxyAvatarModule],
  standalone: true,
})
export class CrmUnknownUserAvatarComponent {
  @Input() width: number = AVATAR_WIDTH;
}
